module.exports = __webpack_public_path__ + "static/01-24dfc509e2f7e8a32541aadff297428a.jpg";